var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNotifications = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.448,
    height: 36,
    viewBox: "0 0 29.448 36",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_258",
    "data-name": "Pfad 258",
    d: "M34,28.734V17.907a9.918,9.918,0,0,0-9-9.861V6H23V8.046a9.918,9.918,0,0,0-9,9.861V28.734L9.276,37H19a5,5,0,0,0,10,0h9.724ZM26.22,35h-13.5L16,29.266V17.907A7.916,7.916,0,0,1,23.906,10h.188A7.916,7.916,0,0,1,32,17.907V29.266L35.276,35H26.22ZM24,40a3,3,0,0,1-3-3h6A3,3,0,0,1,24,40Z",
    transform: "translate(-9.276 -6)"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNotifications);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/notifications.7a0b968df2b34349a72b6b0c2f16f234.svg";